import env from './env';

export const clioManageMatterLink = (matterId: number | string) =>
  `${env.clioBaseUrl}/nc/#/matters/${matterId}`;

export const clioManageMatterDocumentsLink = (matterId: number | string) =>
  `${clioManageMatterLink(matterId)}/documents`;

export const clioWorkTemplatesLink = () => `${env.clioBaseUrl}/work/draft`;

// The firm's "Templates from Clio Draft" folder (inside "Clio Work Templates") in Documents, where copied
// templates are filed, or Clio Work until it's known.
export const clioDraftFolderLink = (folderId?: number | null) =>
  folderId
    ? `${env.clioBaseUrl}/document_management/folders/${folderId}?dms_page=firm`
    : clioWorkTemplatesLink();

// Opens a copied template in the Clio Work editor, or the "Templates from Clio Draft" folder when its
// document isn't known.
export const clioWorkTemplateLink = (
  documentId?: number | null,
  folderId?: number | null,
) =>
  documentId
    ? `${env.clioBaseUrl}/work/draft/documents/${documentId}`
    : clioDraftFolderLink(folderId);
